module.exports = __webpack_public_path__ + "static/media/advincula-logo-pwa@3x.ba7b2dcd.jpg";